<div class="footer footer-16371">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 text-center">

                <div class="social vertical-center">

                    <ul class="list-unstyled">

                        <a href="https://mehulkothari05.medium.com/" class="fa fa-medium"></a>
                        <a href="https://twitter.com/Mehulk2011" class="fa fa-twitter"></a>
                        <a href="https://www.youtube.com/channel/UCrkD5KCLh2ObY7BvFqRMOVA" class="fa fa-youtube"></a>
                        <a href="https://www.instagram.com/mehul_kothari05/" class="fa fa-instagram"></a>
                        <a href="https://github.com/mehulk05/" class="fa fa-github"></a>
                        <a href="javascript:void(0)" class="fa fa-share-alt" (click)="shareLink()"></a>
                    </ul>
                </div>

            </div>

            <div class="col-lg-4 col-md-4 text-center vertical-center">
                <div class="social contact-us mb-1">
                    <h3>Contact us</h3>
                    <div class="contact-detail">

                        <p>
                            <i class="fa fa-envelope"></i>Ahmedabad, India
                        </p>

                    </div>
                </div>

            </div>

        </div>
    </div>
</div>